// Gaps (THPS 3+4): named lines through a level that score a bonus and show
// in the combo string ("Funbox Transfer"). A gap is data on the map: two
// zones and what you have to be doing between them.
//
// - `air`: leave the ground (or a rail) in `from`, land on your wheels in `to`.
// - `grind`: leave the ground (or a rail) in `from`, lock onto a grind in `to`
//   in the same air (kicker to rail, rail to rail).
// - `manual`: start a manual in `from` and still be in it when you reach `to`.
// - `lip`: stall a lip trick on the coping in `from` and drop back in, without
//   bailing, onto the ramp in `to` (one zone over the coping can be both).

/** An axis-aligned rectangle on the ground: center and half-sizes, in meters. */
export interface Zone {
  x: number;
  z: number;
  hx: number;
  hz: number;
}

export const GAP_KINDS = ["air", "grind", "manual", "lip"] as const;
export type GapKind = (typeof GAP_KINDS)[number];

export interface Gap {
  name: string;
  points: number;
  kind: GapKind;
  from: Zone;
  to: Zone;
}

export function inZone(zone: Zone, x: number, z: number): boolean {
  return Math.abs(x - zone.x) <= zone.hx && Math.abs(z - zone.z) <= zone.hz;
}

/** The gaps of this kind a line from `a` to `b` makes. */
export function gapsHit(gaps: readonly Gap[], kind: GapKind, a: { x: number; z: number }, b: { x: number; z: number }): Gap[] {
  return gaps.filter((g) => g.kind === kind && inZone(g.from, a.x, a.z) && inZone(g.to, b.x, b.z));
}
